import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BookCard.module.css';

const BookCard = ({ book, showDetails = false, showStatus = false, from }) => {
  const navigate = useNavigate();
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  
  const handleClick = () => {
    console.log('点击书籍:', book.title);
    // 跳转到书籍详情页，传递来源页面信息
    navigate(`/book/${book.id}`, { state: { from } });
  };

  const handleReadClick = (e) => {
    e.stopPropagation(); // 阻止事件冒泡
    navigate(`/book/${book.id}`, { state: { from } });
  };





  // 获取书籍状态
  const getBookStatus = () => {
    if (book.is_completed !== undefined) {
      return book.is_completed ? '完结' : '连载中';
    }
    return book.status || '未知';
  };

  return (
    <div className={styles.bookCard} onClick={handleClick}>
      <div className={styles.bookCardContent}>
        
        <div className={styles.bookInfo}>
          <div className={styles.bookMainInfo}>
            <h3 className={styles.bookTitle}>{book.title}</h3>
            <p className={styles.bookAuthor}>作者：{book.author}</p>
            {/* {(book.category || book.chapters || showStatus) && (
              <div className={styles.bookMeta}>
                {book.category && (
                  <span className={styles.bookCategory}>{book.category}</span>
                )}
                {(showStatus || book.is_completed !== undefined || book.status) && (
                  <span className={styles.bookStatusBadge}>{getBookStatus()}</span>
                )}
                {book.chapters && (
                  <span className={styles.bookChapters}>{book.chapters}章</span>
                )}
              </div>
            )} */}
     
          
          </div>
          
          {showDetails && (
            <div className={styles.bookDetails}>
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>状态：</span>
                <span className={styles.detailValue}>{getBookStatus()}</span>
              </div>
              {book.categories && book.categories.length > 0 && (
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>分类：</span>
                  <span className={styles.detailValue}>
                    {book.categories.map(cat => cat.name).join(', ')}
                  </span>
                </div>
              )}
              {book.createdAt && (
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>创建时间：</span>
                  <span className={styles.detailValue}>
                    {new Date(book.createdAt).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      {book.description && (
        <div className={styles.bookDescriptionSection}>
          <p className={styles.bookDescription}>
            {book.description.length > 100 
              ? `${book.description.substring(0, 100)}...` 
              : book.description
            }
          </p>
        </div>
      )}
      
  
    </div>
  );
};

export default BookCard;
